export default __webpack_public_path__ + "static/media/app_store.e3bbd12f.svg";